import { Button } from '@/components/ui/button';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { TabsContent } from '@radix-ui/react-tabs';
import DepositList from './deposits/DepositeList';
import WithdrawalList from './withdrawals/WithdrawalList';

export default function DepositWithdrawalRequest() {
  return (
    <div>
      <div className="p-2 flex justify-between items-center bg-gray-800">
        <div className="flex items-center gap-4">
          <span>
            Balance Down:
            <span className="text-green-500"> 9,43,122</span>
          </span>
          <span>
            Balance Up:
            <span className="text-red-500"> 0</span>
          </span>
          <span>
            Available Credit:
            <span className="text-green-500"> 5,41,532</span>
          </span>
        </div>
        <Button size="sm" variant="outline" className="">
          refresh
        </Button>
      </div>
      <h2 className="my-2 text-2xl font-semibold">Deposit/Withdrawal Requests</h2>
      <Tabs defaultValue="deposite">
        <TabsList className="sm:w-1/4 flex justify-evenly my-5 bg-transparent">
          <TabsTrigger
            value="deposite"
            className="
        px-5 py-3 rounded-lg border-2
        data-[state=active]:bg-green-500
        data-[state=active]:text-white
        data-[state=active]:border-green-500
      "
          >
            Deposit
          </TabsTrigger>

          <TabsTrigger
            value="withdrawal"
            className="
        px-5 py-3 rounded-lg border-2
        data-[state=active]:bg-red-500
        data-[state=active]:text-white
        data-[state=active]:border-red-500
      "
          >
            Withdrawal
          </TabsTrigger>
        </TabsList>

        <TabsContent value="deposite">
          <DepositList />
        </TabsContent>

        <TabsContent value="withdrawal">
          <WithdrawalList />
        </TabsContent>
      </Tabs>
    </div>
  );
}
